import cleanUrl from './clean-url';

const LATENCY_CONST = 'latency';
const SUCCESS_CONST = 'success';

const composeMetricSlug = ({
  endpoint,
  method,
}: {
  endpoint: string;
  method: string;
}) => {
  const sanitizedUrl = cleanUrl(endpoint);
  const metricSlug = `${sanitizedUrl}:${method}`;
  return {
    sanitizedUrl,
    metricSlug,
    latencyMetricSlug: [metricSlug, LATENCY_CONST].join(':'),
    successMetricSlug: [metricSlug, SUCCESS_CONST].join(':'),
  };
};

export default composeMetricSlug;
